module.exports = __webpack_public_path__ + "assets/ic_cart_x-d0052d.svg";